import { render, staticRenderFns } from "./StoriesGrid.vue?vue&type=template&id=2f945fc1&scoped=true"
import script from "./StoriesGrid.vue?vue&type=script&lang=js"
export * from "./StoriesGrid.vue?vue&type=script&lang=js"
import style0 from "./StoriesGrid.vue?vue&type=style&index=0&id=2f945fc1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f945fc1",
  null
  
)

export default component.exports